export const overviewFilterSchema = [
  {
    id: "pspCode",
    label: "Processors",
    type: "text",
    multiselector: true,
    displayLogo: true,
    items: ["data is updated from api"],
  },
  {
    id: "paymentMethodType",
    label: "Payment Category",
    type: "text",
    multiselector: true,
    displayLogo: false,
    showTitleType: true,
    uniqueType: true,
    items: ["data is updated from api"],
  },
];

export const overviewFilterSchemaForFailureReason = [
  {
    id: "pspCode",
    label: "Processors",
    type: "text",
    multiselector: true,
    displayLogo: true,
    items: ["data is updated from api"],
  },
];
